import { FormikProps } from 'formik';
import _, { PropsWithChildren } from 'react';
import { WsRadioGroup, WsRadioGroupProps } from 'stories/inputs/WsRadioGroup';

interface WsFormRadioGroupProps extends WsRadioGroupProps {
  id: string;
  formik: FormikProps<any>;
  onChange?: (...args: any[]) => void;
}

export const WsFormRadioGroup = ({ formik, onChange, ...props }: PropsWithChildren<WsFormRadioGroupProps>) => {
  return (
    <WsRadioGroup
      value={formik.values[props.id] || ''}
      onChange={onChange ? onChange : formik.handleChange}
      {...props}
    />
  );
};
